import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../lib/supabase';
import { getAziendaUsage } from '../../lib/services/statusService'; // DODANO: Import servisa
import DashboardSidebar from '../../components/navigation/DashboardSidebar';
import DashboardHeader from '../../components/navigation/DashboardHeader';
import DashboardFooter from '../../components/navigation/DashboardFooter';
import MobileMenuButton from '../../components/navigation/MobileMenuButton';
import WelcomeCardOwner from './components/WelcomeCardOwner';
import StatCardOwner from './components/StatCardOwner'; 
import HeroSectionOwner from './components/HeroSectionOwner';
import QuickActionCardOwner from './components/QuickActionCardOwner';
import RecentActivityCardOwner from './components/RecentActivityCardOwner';
import ListaDipendenti from '../../components/navigation/ListaDipendenti';

const HomeDashboardOwner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  // STATE ZA PODATKE
  const [adminData, setAdminData] = useState({ id_azienda: null, nome: '' });
  const [myDocsCount, setMyDocsCount] = useState('...');
  const [totalEmployees, setTotalEmployees] = useState('...');
  const [totalCompanies, setTotalCompanies] = useState('...'); 
  const [currentPlan, setCurrentPlan] = useState('...'); // DODANO: State za plan
  const [recentActivities, setRecentActivities] = useState([]);

  useEffect(() => {
    const getAdminContext = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          // 1. Profil
          const { data: profilo } = await supabase
            .from('profili')
            .select('id_azienda, nome, cognome')
            .eq('id', user.id)
            .single();
          
          if (profilo) {
            const fullName = `${profilo.nome} ${profilo.cognome}`;
            setAdminData({ id_azienda: profilo.id_azienda, nome: fullName });

            // DOHVATANJE PLANA (Za ID 4)
            const resUsage = await getAziendaUsage(profilo.id_azienda);
            if (resUsage.success) {
              setCurrentPlan(resUsage.data.plan || 'Basic');
            }

            // Aktivnost
            if (user.last_sign_in_at) {
              setRecentActivities([{
                id: 1,
                type: 'login',
                title: t('home_dipendente.activities.login_title'),
                description: t('home_dipendente.activities.login_desc'),
                timestamp: new Date(user.last_sign_in_at),
                user: { name: fullName, avatar: "" }
              }]);
            }

            // 2. Brojač radnika za tvoju firmu
            const { count: empCount } = await supabase
              .from('profili')
              .select('*', { count: 'exact', head: true })
              .eq('id_azienda', profilo.id_azienda);
            if (empCount !== null) setTotalEmployees(empCount.toString());
          }

          // 3. Brojač tvojih dokumenata
          const { count: docCount } = await supabase
            .from('documenti')
            .select('*', { count: 'exact', head: true })
            .eq('id_utente', user.id)
            .eq('is_deleted', false);
            
          if (docCount !== null) setMyDocsCount(docCount.toString());

          // 4. Brojač svih kompanija
          const { count: companiesCount } = await supabase
            .from('aziende')
            .select('*', { count: 'exact', head: true });
          if (companiesCount !== null) setTotalCompanies(companiesCount.toString());
        }
      } catch (err) {
        console.error("Errore fetch stats:", err.message);
        setCurrentPlan('N/A');
      }
    };
    getAdminContext();
  }, [t]);

  const statsData = [
   { 
      id: 1, 
      title: 'home_superadmin.stats.active_sessions', 
      value: myDocsCount, 
      icon: 'FileText', 
      iconColor: 'var(--color-primary)',
      onClick: () => navigate('/my-documents')
    },
    { 
      id: 2, 
      title: 'home_superadmin.stats.total_employees', 
      value: totalEmployees, 
      icon: 'Users', 
      iconColor: 'var(--color-success)' 
    },
    { 
      id: 3, 
      title: 'home_superadmin.stats.total_aziende', 
      value: totalCompanies, 
      icon: 'Building2', 
      iconColor: 'var(--color-warning)',
      onClick: () => navigate('/lista-companies')
    },
    {
      id: 4,
      title: 'home_superadmin.stats.avg_time', 
      value: (
        <div className="flex flex-col items-start gap-2 py-1">
          <span className="text-[0.85em] uppercase tracking-[0.15em] font-black leading-tight text-foreground">
            {currentPlan}
          </span>
          <span className="text-[12px] font-normal text-muted-foreground leading-tight">
            {t('home_superadmin.stats.check_usage')}
          </span>
        </div>
      ),
      icon: 'Activity', 
      iconColor: 'var(--color-accent)',
      onClick: () => navigate('/stats') 
    }
  ];

  // Quick actions, logout i ostalo ostaju isti...

  // Quick actions ostaju isti...
  const quickActions = [
    { id: 1, title: t('home_superadmin.actions.profile.title'), description: t('home_superadmin.actions.profile.desc'), icon: 'User', iconColor: 'var(--color-primary)', onClick: () => navigate('/mio-profilo') },
    { id: 2, title: t('home_superadmin.actions.settings.title'), description: t('home_superadmin.actions.settings.desc'), icon: 'Settings', iconColor: 'var(--color-secondary)', onClick: () => navigate('/settings') },
    { id: 5, title: t('home_superadmin.actions.create_employee.title'), description: t('home_superadmin.actions.create_employee.desc'), icon: 'UserPlus', iconColor: 'var(--color-success)', onClick: () => navigate('/crea-dipendente') },
{ 


       id: 7,
      title: t('home_superadmin.actions.holidays_management.title'),
      description: t('home_superadmin.actions.holidays_management.desc'),
      icon: 'CalendarCheck',
      iconColor: '#f59e0b',
      onClick: () => navigate('/admin-holidays')
    },
    {

      id: 6, 
      title: t('home_superadmin.actions.inventory.title'), 
      description: t('home_superadmin.actions.inventory.desc'), 
      icon: 'Database', 
      iconColor: '#1fa65aff', 
      onClick: () => navigate('/acv-home') 
    },
  
     
    { 
      id: 4, 
      title: t('home_superadmin.actions.trash.title'), 
      description: t('home_superadmin.actions.trash.desc'), 
      icon: 'Trash2', 
      iconColor: '#ef4444', 
      onClick: () => navigate('/restore-documents') 
    },

  
  ];

  const handleLogout = () => navigate('/landing-authentication');
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <MobileMenuButton isOpen={isSidebarOpen} onClick={toggleSidebar} />
      <DashboardSidebar isCollapsed={!isSidebarOpen} onToggle={toggleSidebar} />
      <DashboardHeader onLogout={handleLogout} userName={adminData.nome || 'Admin'} />

      <main className="main-content with-sidebar">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
          <WelcomeCardOwner userName={adminData.nome} />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-6 md:mt-8">
            {statsData.map((stat) => (
              <StatCardOwner key={stat.id} {...stat} />
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8">
            <div className="lg:col-span-2 space-y-8">
               <h2 className="text-xl md:text-2xl font-black uppercase tracking-tighter text-foreground">
                {t('dipendenti_list.title')}
              </h2>
              <ListaDipendenti idAzienda={adminData.id_azienda} />
            </div>

            <div className="space-y-8">
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tighter text-foreground">
                {t('home_superadmin.sections.quick_actions')}
              </h2>
              <div className="grid grid-cols-1 gap-4">
                {quickActions.map((action) => (
                  <QuickActionCardOwner key={action.id} {...action} />
                ))}
              </div>
              <RecentActivityCardOwner activities={recentActivities} />
            </div>
          </div>

          <div className="mt-12">
            <HeroSectionOwner onRegisterClick={() => navigate('/crea-azienda')} />
          </div>
        </div>
      </main>
      <DashboardFooter />
    </div>
  );
};

export default HomeDashboardOwner;